import {
  Directive,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { StyleLoaderService } from '@nibtravel/shared/util/style-loader';
import { ILogoConfig } from '@nibtravel/shared/ui/components/logo';
import { ThemeLoaderService } from './theme-loader.service';

export interface ITheme {
  brand: string;
  theme?: string;
  logo: ILogoConfig;
  title?: string;
  isStandalone?: boolean
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[theme]',
  exportAs: 'theme',
})
export class ThemeDirective implements OnChanges {
  @Input() theme!: ITheme;
  @Output() themeLoaded = new EventEmitter<ITheme>();

  logoChanged$ = this.themeLoaded.asObservable();

  constructor(
    private themeLoader: ThemeLoaderService,
    private styleLoaderService: StyleLoaderService
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.theme?.currentValue) {
      await this.initTheme();
    }
  }

  async initTheme(): Promise<void> {
    this.styleLoaderService.initTheming(
      this.theme.brand,
      this.theme.title ?? 'Travel Insurance',
      this.theme.theme ?? '',
      this.theme?.isStandalone ?? false,
    );
    await this.themeLoader.load(this.theme.brand);

    this.themeLoaded.emit(this.theme);
  }
}
